module.exports = __webpack_public_path__ + "static/media/map.7c1eab84.png";